export default __webpack_public_path__ + "static/media/logo.4d6c7226.svg";